<template>
  <div class="login-container">
    <van-cell-group>
      <van-field v-model="loginForm.username" label="用户名" placeholder="请输入用户名" required/>
      <van-field v-model="loginForm.password" type="password" label="密码" placeholder="请输入密码" required/>
      <van-field v-model="loginForm.code" label="验证码" placeholder="请输入验证码" required>
        <template #button>

          <img :src="codeUrl" @click="getCode" class="captcha-image"/>
        </template>
      </van-field>
    </van-cell-group>
    <van-button class="m-t-20" type="info" block @click="login">登录</van-button>

  </div>
</template>

<script>
import {getCodeImg, login} from "@/api/login";

import {Toast} from 'vant';

export default {
  data() {
    return {
      codeUrl: "",
      loginForm: {
        // username: "admin",
        // password: "hlxx12#$",
        username: "",
        password: "",
        rememberMe: false,
        code: "",
        uuid: "",
        redirect: ""
      },
      // 验证码开关
      captchaEnabled: true,
    };
  },
  created() {
    this.getCode();
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
        if (!this.redirect) {
          this.redirect = '/'
        }
      },
      immediate: true
    }
  },
  methods: {
    onSubmit(values) {
      this.login()
    },
    getCode() {
      getCodeImg().then(res => {
        this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled;
        if (this.captchaEnabled) {
          this.codeUrl = "data:image/gif;base64," + res.img;
          this.loginForm.uuid = res.uuid;
        }
      });
    },
    login() {
      this.$store.dispatch("Login", this.loginForm).then(() => {
        this.$router.push({path: this.redirect}).catch(() => {
        });
      }).catch((e) => {
        Toast.fail(e.message);
        if (this.captchaEnabled) {
          this.getCode();
        }
      });
    }
  },
};
</script>

<style rel="stylesheet/scss" lang="less">
.login-container {
  padding: 20px;
}

.captcha-image {
  width: 100px;
  height: 40px;
  cursor: pointer;
}
</style>
